import { Client } from "../types/internal";
import {
  Cart,
  CartCheckoutInput,
  CartCheckoutResult,
  CartItem,
  CartItemInput,
  CartItemUpdateOptions,
} from "../models/Cart";
import { isString } from "../utils/data";

export const createCart = (client: Client) => ({
  get: (cartId: string, upsert?: boolean) => {
    const url = client.urls.carts(cartId);
    return client.get<Cart>(url, {
      data: { upsert: !!upsert },
    });
  },
  add: (cartId: string, item: CartItemInput | string) => {
    const url = client.urls.carts(cartId, "line");
    const data = isString(item) ? { gid: item } : item;

    return client.post<{ item: CartItem; cart: Cart }>(url, { data });
  },
  addItems: (cartId: string, items: (CartItemInput | string)[]) => {
    const url = client.urls.carts(cartId, "lines");
    const formatted = items.map((item) => {
      return isString(item) ? { gid: item } : item;
    });

    return client.post<{ items: CartItem[]; cart: Cart }>(url, {
      data: {
        items: formatted,
      },
    });
  },
  update: (cartId: string, itemId: string, data: CartItemUpdateOptions) => {
    const url = client.urls.carts(cartId, "lines", itemId);
    return client.post<{ item: CartItem; cart: Cart }>(url, { data });
  },
  remove: (cartId: string, itemId: string) => {
    const url = client.urls.carts(cartId, "lines", itemId);
    return client.delete<Cart>(url);
  },
  clear: (cartId: string) => {
    const url = client.urls.carts(cartId, "clear");
    return client.post<Cart>(url);
  },
  checkout: (cartId: string, data?: CartCheckoutInput) => {
    const url = client.urls.carts(cartId, "checkout");
    return client.post<CartCheckoutResult>(url, {
      data: {
        cancel_url: window.location.href,
        ...data,
      },
    });
  },
  create: () => {
    const url = client.urls.carts();
    return client.post<Cart>(url);
  },
});
